module.exports = __webpack_public_path__ + "img/arr_repetition.11ac6299.svg";